import { styled } from "@mui/material/styles";
import { Box, Button } from "@mui/material";

export const AgentOptionsRow = styled(Box)(() => ({
  display: "flex",
  flexWrap: "wrap",
  gap: "10px",
  marginTop: "12px",
  paddingLeft: "46px",
}));

export const AgentOption = styled(Button)(({ theme }) => ({
  color: theme.palette.text.primary,
  border: `1.5px solid ${theme.palette.text.primary}`,
  backgroundColor: "transparent",
  borderRadius: "10px",
  textTransform: "none",
  fontWeight: 600,
  fontSize: "14px",
  lineHeight: 1.4,
  padding: "8px 18px",
  minWidth: "auto",
  transition:
    "transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease, color 0.18s ease, border-color 0.18s ease",
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
    border: `1.5px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
    transform: "translateY(-1px)",
    boxShadow: `0 4px 12px ${theme.palette.primary.main}1f`,
  },
  "&:active": {
    transform: "translateY(0)",
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    opacity: 0.6,
    color: theme.palette.text.primary,
    border: `1.5px solid ${theme.palette.divider}`,
  },
}));
